import {
    ChangeDetectorRef,
    Component,
    ContentChildren,
    ElementRef,
    Host,
    HostBinding,
    Input,
    Optional,
    QueryList,
    SkipSelf,
} from "@angular/core";
import { ControlContainer } from "@angular/forms";
import { AttributePresenceInput } from "@spscommerce/ng-utils";

import { SpsAbstractFieldsetComponent } from "../forms/sps-abstract-fieldset.abstract.component";
import { SpsFormControlComponent } from "../forms/sps-form-control.abstract.component";

@Component({
    selector: "sps-input-group, sps-icon-button-set",
    templateUrl: "./sps-input-group.component.html"
})
export class SpsInputGroupComponent extends SpsAbstractFieldsetComponent {
    @Input() @AttributePresenceInput() stacked: boolean;

    @ContentChildren(SpsFormControlComponent) children: QueryList<SpsFormControlComponent<any>>;

    @HostBinding("class.sps-form-group") readonly spsFormGroupClass = true;

    @HostBinding("class.sps-form-control--focused")
    get isFocused() {
        return this.children && this.children.some(c => c.isFocused);
    }

    @HostBinding("class.sps-form-group--error")
    get isInErrorState() {
        return this.children && this.children.some(c => c.isInErrorState);
    }

    @HostBinding("class.sps-form-group--required")
    get isRequired() {
        return this.children && this.children.some(c => c.isRequired);
    }

    constructor(
        changeDetector: ChangeDetectorRef,
        @Optional()
        @Host()
        @SkipSelf()
        ctrlContainer: ControlContainer,
        elementRef: ElementRef
    ) {
        super(changeDetector, ctrlContainer, elementRef);
    }
}
